import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import { SERVER_URL } from "./ConstantsHealthCalculator";
import { Calories_EndPoint } from "./ConstantsHealthCalculator";
import CaloriesTable from "./CaloriesTable";
import SharedHelmet from "../Helmet";
const TITLE = "Calculatrice calories par jour (TDEE)";
const DESCRIPTION =
  "Estimez vos besoins caloriques journaliers selon votre age, taille, poids, sexe et activite. Utilisez ce resultat pour maintenir, perdre ou prendre du poids de facon progressive.";
const KEYWORDS =
  "calculatrice calories, calories par jour, besoins caloriques, TDEE, perte de poids calories, maintien du poids";
const OG_URL = "https://do-calculate.com/calculator/fr/calories/";
const apiEndpoint = `${SERVER_URL}/${Calories_EndPoint}`;
function CaloriesCalculator() {
  const [weight, setWeight] = useState("");
  const [height, setHeight] = useState("");
  const [age, setAge] = useState("");
  const [gender, setGender] = useState("");
  const [result, setRestul] = useState(null);
  const [error, setError] = useState(null);
  const [statusCode, setStatusCode] = useState(null);
  const [classification, setClassification] = useState(null);
  const [activity, setActivity] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const handleWeightChange = (event) => {
    setWeight(event.target.value);
  };
  const handleHeightChange = (event) => {
    setHeight(event.target.value);
  };
  const handleAgeChange = (event) => {
    setAge(event.target.value);
  };
  const handleGenderChange = (event) => {
    setGender(event.target.value);
  };
  const handleActivityChange = (event) => {
    setActivity(event.target.value);
  };
  const calculateCalories = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ activity, weight, height, age, gender }),
      });
      const data = await response.json();
      setStatusCode(response.status);
      if (response.ok) {
        setRestul(data.result);
        setError(null);
        setClassification(data.result.classification);
      } else {
        setRestul(null);
        setError(data.error);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                La calculatrice des calories est un calcul qui détermine le nombre de calories consommées quotidiennement par une personne (homme/femme) en fonction de plusieurs facteurs tels que le poids, la taille, l'âge et le type d'activité physique quotidienne. Vous pouvez calculer les calories de votre corps et estimer combien de calories votre corps a besoin. Vous pouvez également utiliser cette calculatrice pour connaître les calories nécessaires pour gagner et perdre du poids
                <br />
                Cette calculatrice prend en compte des facteurs tels que le niveau d'activité physique, le poids, la taille, l'âge et le sexe pour fournir des recommandations de calories personnalisées pour vos besoins individuels. De plus, il vous fournit des conseils simples pour la gestion du poids, y compris la perte ou la prise de poids et l'atteinte d'un équilibre sain en fonction des calories dont votre corps a besoin quotidiennement.
                <br />
                Utilisez la calculatrice des calories pour savoir combien de calories votre corps a besoin pour maintenir un poids santé et un mode de vie actif
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-12 col-md-5 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  Calories pour gain/perte de poids
                </div>
                <hr />
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="height" className="form-label ms-2">
                      Taille
                    </label>
                  </b>
                  <input
                    type="number"
                    id="heightNumber"
                    value={height}
                    onChange={handleHeightChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                    placeholder="175"
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">cm</span>
                  </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="weightNumber" className="form-label ms-2">
                      Poids
                    </label>
                  </b>
                  <input
                    type="number"
                    id="weightNumber"
                    value={weight}
                    onChange={handleWeightChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                    placeholder="65"
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">kg</span>
                  </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="age" className="form-label ms-2">
                      Âge
                    </label>
                  </b>
                  <input
                    type="number"
                    id="age"
                    value={age}
                    onChange={handleAgeChange}
                    className="form-control"
                    style={{ width: "90%" }}
                    placeholder="6"
                    min="2"
                    max="20"
                  />
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label >Sexe</label>
                  </b>
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      id="male"
                      name="gender"
                      value="male"
                      checked={gender === "male"}
                      onChange={handleGenderChange}
                      className="form-check-input"
                    />
                    <label className="form-check-label" htmlFor="male">
                      Homme
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      id="female"
                      name="gender"
                      value="female"
                      checked={gender === "female"}
                      onChange={handleGenderChange}
                      className="form-check-input"
                    />
                    <label className="form-check-label" htmlFor="female">
                      Femme
                    </label>
                  </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="activity">Niveau d'activité :</label>
                  </b>
                  <select
                    id="activity"
                    className="form-select"
                    value={activity}
                    onChange={handleActivityChange}
                  >
                    <option value="">Sélectionner</option>
                    <option value="sedentary">Sédentaire</option>
                    <option value="light">Léger</option>
                    <option value="moderate">Modéré</option>
                    <option value="very">Très actif</option>
                    <option value="extra">Extra actif</option>
                  </select>
                </div>
                <br />
                <hr />
                <button
                  className="btn btn-success"
                  style={{ fontSize: "20px" }}
                  onClick={calculateCalories}
                  disabled={isLoading}
                >
                  Calculer
                </button>
              </div>
              <div className="col-sm-12 col-md-7">
                {result && (
                  <div>
                    <div className="alert alert-success">
                      <h5>Résultats : </h5>
                      Vos calories quotidiennes : {result.calories} kcal.
                    </div>
                    <hr />
                    <CaloriesTable result={result}></CaloriesTable>{" "}
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col">
                {statusCode === 400 && (
                  <div className="alert alert-warning">
                    <b>
                      <u>Erreur :</u>
                    </b>{" "}
                    Veuillez saisir tous les champs correctement.{" "}
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto", marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Conseils d'utilisation</h3></div>
              <div className="info-section-body">
                <p>Entrez des donnees recentes (poids, activite hebdomadaire) et gardez la meme methode de suivi d'une semaine a l'autre. Ajustez vos calories progressivement selon vos resultats reels.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>Calculatrice des calories - Estimer vos besoins journaliers</strong>
              </div>
              <div className="info-section-body">
                <h2 style={{ fontSize: "16px", marginBottom: "10px" }}>
                  Les calories et comment les calculer pour une nutrition correcte
                </h2>
                <p style={{ lineHeight: "1.8" }}>
                  Les calories representent l'energie que votre corps utilise chaque jour. Connaitre votre besoin calorique vous aide a structurer vos repas, mieux gerer votre faim et avancer vers un objectif realiste: maintien, perte ou prise de poids.
                </p>
                <hr />
                <h2 style={{ fontSize: "16px", marginTop: "15px", marginBottom: "10px" }}>Qu'est-ce qu'une calorie ?</h2>
                <p style={{ lineHeight: "1.8" }}>
                  Une calorie est une unité de mesure d'énergie. C'est l'énergie utilisée par votre corps pour effectuer ses fonctions essentielles telles que la respiration, le pompage du sang et d'autres fonctions organiques. Toute activité physique ou mouvement nécessite également de l'énergie, que ce soit faire de l'exercice à la salle de gym ou faire des activités quotidiennes.
                </p>
                <hr />
                <h2 style={{ fontSize: "16px", marginTop: "15px", marginBottom: "10px" }}>
                  Comment calculer les calories dont votre corps a besoin
                </h2>
                <p style={{ lineHeight: "1.8" }}>
                  Il existe de nombreuses façons de calculer les calories dont votre corps a besoin, mais la méthode la plus courante est basée sur les facteurs suivants:
                </p>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>Poids :</strong> Plus vous êtes lourd, plus votre corps a besoin de calories pour maintenir ses fonctions vitales.
                  </li>
                  <li>
                    <strong>Taille :</strong> Les personnes plus grandes ont généralement besoin de plus de calories en raison de plus de cellules et de tissus dans leurs corps.
                  </li>
                  <li>
                    <strong>Âge :</strong> En vieillissant, vous pourriez avoir besoin de moins de calories en raison des changements du taux métabolique.
                  </li>
                  <li>
                    <strong>Activité physique :</strong> Les personnes qui font régulièrement de l'exercice ont besoin de plus de calories pour répondre aux exigences d'activité physique.
                  </li>
                </ul>
                <hr />
                <h2 style={{ fontSize: "16px", marginTop: "15px", marginBottom: "10px" }}>
                  Formule de calcul des calories
                </h2>
                <p style={{ lineHeight: "1.8" }}>
                  Le taux métabolique basal (TMB) est calculé en fonction de l'âge, du poids, de la taille et du sexe en utilisant la formule de Harris-Benedict modifiée. La formule Harris-Benedict était l'une des plus anciennes formules utilisées pour calculer le taux métabolique basal (TMB), qui est la quantité d'énergie dépensée quotidiennement au repos. Elle a été révisée en 1984 pour être plus précise.
                </p>
                <div className="alert alert-info" style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <strong>Formule Harris-Benedict révisée : </strong><br/>
                  <strong>Hommes : </strong>TMB = 13.397P + 4.799T - 5.677A + 88.362<br/>
                  <strong>Femmes : </strong>TMB = 9.247P + 3.098T - 4.330A + 447.593<br/>
                  <strong>Où :</strong>
                  <ul style={{ marginTop: "8px" }}>
                    <li>P = poids corporel en kilogrammes</li>
                    <li>T = taille corporelle en centimètres</li>
                    <li>A = âge</li>
                  </ul>
                </div>
                <p style={{ lineHeight: "1.8", marginTop: "10px" }}>
                  Le nombre total de calories brûlées est calculé en fonction du niveau d'activité et du taux métabolique basal (TMB). Les estimations des calories quotidiennes sont calculées en fonction des objectifs de poids souhaités, y compris le maintien du poids, la perte de poids et la prise de poids.
                </p>
              </div>
            </div>

            <div className="info-section">
              <div className="info-section-header">
                <strong>Utilisation et applications de la calculatrice</strong>
              </div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "17px", marginBottom: "10px" }}>Pour la gestion du poids et la nutrition :</h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li><strong>Suivi des calories :</strong> Pour ceux qui comptent leurs calories quotidiennes dans le cadre d'un régime alimentaire</li>
                  <li><strong>Gestion de l'énergie :</strong> Aide à comprendre comment l'activité physique affecte vos besoins énergétiques</li>
                  <li><strong>Équilibre nutritionnel :</strong> Vous aide à savoir combien vous devez compenser avec d'autres repas</li>
                  <li><strong>Accomplissement des objectifs :</strong> Essentiel pour atteindre un poids santé et un mode de vie actif</li>
                </ul>
                <h3 style={{ fontSize: "17px", marginTop: "15px", marginBottom: "10px" }}>Pour les professionnels de la santé :</h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li><strong>Plans nutritionnels :</strong> Préparation de plans alimentaires personnalisés pour les patients</li>
                  <li><strong>Recommandations personnalisées :</strong> Fourniture de recommandations précises basées sur les données individuelles</li>
                  <li><strong>Suivi des progrès :</strong> Évaluation et suivi des changements de poids et de composition corporelle</li>
                </ul>
                <h3 style={{ fontSize: "17px", marginTop: "15px", marginBottom: "10px" }}>Dans la vie quotidienne :</h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li><strong>Sensibilisation :</strong> Meilleure compréhension de vos besoins énergétiques</li>
                  <li><strong>Planification des repas :</strong> Aide à planifier les repas de manière plus consciente</li>
                  <li><strong>Choix éclairés :</strong> Permet de faire des choix plus judicieux concernant l'alimentation et l'exercice</li>
                </ul>
              </div>
            </div>

            <div className="info-section">
              <div className="info-section-header">
                <strong>Erreurs courantes à éviter</strong>
              </div>
              <div className="info-section-body">
                <ul style={{ lineHeight: "1.8" }}>
                  <li><strong>Ignorer le niveau d'activité :</strong> Beaucoup oublient que l'exercice augmente significativement les besoins en calories</li>
                  <li><strong>Oublier les boissons :</strong> Les boissons contiennent aussi des calories et doivent être comptabilisées</li>
                  <li><strong>Penser que toutes les calories sont identiques :</strong> La source des calories importe aussi pour la santé</li>
                  <li><strong>Réduction drastique des calories :</strong> Manger trop peu ralentit le métabolisme et peut être dangereux</li>
                  <li><strong>Ne pas tenir compte des variations individuelles :</strong> Chaque personne est différente, les estimations sont des guides</li>
                </ul>
              </div>
            </div>

            <div className="info-section">
              <div className="info-section-header">
                <strong>Conseils pratiques pour gérer les calories</strong>
              </div>
              <div className="info-section-body">
                <ul style={{ lineHeight: "1.8" }}>
                  <li><strong>Augmentez votre activité :</strong> L'exercice régulier augmente vos besoins métaboliques et aide à brûler des calories</li>
                  <li><strong>Construisez des muscles :</strong> Plus de masse musculaire signifie un métabolisme plus rapide au repos</li>
                  <li><strong>Mangez des aliments denses en nutriments :</strong> Préférez les aliments naturels and non transformés</li>
                  <li><strong>Buvez de l'eau :</strong> L'eau n'a pas de calories et aide à la satiété</li>
                  <li><strong>Dormir suffisamment :</strong> Le sommeil affecte le métabolisme et l'appétit</li>
                  <li><strong>Soyez constant :</strong> Les changements durables prennent du temps</li>
                </ul>
              </div>
            </div>

            <div className="info-section">
              <div className="info-section-header">
                <strong>Questions fréquemment posées</strong>
              </div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "17px", marginBottom: "8px" }}>Combien de calories avez-vous besoin ?</h3>
                <p style={{ lineHeight: "1.8" }}>
                  Le nombre de calories dont vous avez besoin dépend de votre âge, de la taille de votre corps et de votre niveau d'activité - la plupart des adolescents et des adultes ont besoin d'environ 1500 à 2500 calories par jour. Plus vous êtes grand, plus vous avez besoin de calories pour maintenir votre poids. Si vous voulez prendre du poids, vous devez manger plus de calories, et si vous voulez perdre du poids, vous devez manger moins de calories ou faire plus d'activité physique.
                </p>

                <h3 style={{ fontSize: "17px", marginTop: "15px", marginBottom: "8px" }}>Combien de calories dans les matières grasses ?</h3>
                <p style={{ lineHeight: "1.8" }}>
                  Les matières grasses contiennent approximativement 9 calories par gramme, ce qui les rend une source très élevée de calories. Lorsque vous consommez de grandes quantités de graisses, cela peut contribuer à augmenter le nombre de calories que vous consommez quotidiennement et ainsi prendre du poids si vous ne faites pas assez d'activité physique pour les brûler.
                </p>

                <h3 style={{ fontSize: "17px", marginTop: "15px", marginBottom: "8px" }}>Quel est l'impact des activités physiques sur les calories ?</h3>
                <p style={{ lineHeight: "1.8" }}>
                  Le mouvement, le levage d'objets et la réalisation de diverses activités nécessitent de l'énergie, donc plus vous bougez et plus vous levez, poussez ou traînez d'objets, plus le nombre de calories dont vous avez besoin augmente. De plus, l'entraînement d'endurance qui augmente la masse musculaire augmente le taux métabolique, ce qui signifie que votre corps a besoin de plus de calories - même au repos.
                </p>

                <h3 style={{ fontSize: "17px", marginTop: "15px", marginBottom: "8px" }}>Quelle est la précision des calculatrices de calories ?</h3>
                <p style={{ lineHeight: "1.8" }}>
                  Les calculatrices de calories sont assez précises mais peuvent ne pas être exactes à 100%. La plupart sont basées sur la formule de Harris Benedict, qui détermine le taux métabolique basal. C'est difficile de savoir exactement combien de calories vous brûlez, car cela varie d'une personne à l'autre et de jour en jour. Ces calculatrices sont un bon point de départ, mais vous pourrez ajuster vos consommations selon votre progrès.
                </p>

                <h3 style={{ fontSize: "17px", marginTop: "15px", marginBottom: "8px" }}>Quel est le meilleur moyen de suivre les calories ?</h3>
                <p style={{ lineHeight: "1.8" }}>
                  De nos jours, la meilleure façon est d'utiliser une application de suivi des calories, comme MyFitnessPal. Vous pouvez enregistrer les aliments et les boissons que vous consommez, et l'application calculera automatiquement les calories et vous donnera une estimation nutritionnelle quotidienne. C'est précis, pratique et souvent gratuit.
                </p>

                <h3 style={{ fontSize: "17px", marginTop: "15px", marginBottom: "8px" }}>Que signifie « Toutes les calories ne sont pas égales » ?</h3>
                <p style={{ lineHeight: "1.8" }}>
                  Toutes les calories sont égales en termes d'énergie - chaque gramme de glucides et de protéines = 4 calories, chaque gramme de graisse = 9 calories. Cependant, la phrase signifie que certaines sources de calories sont nutritionnellement supérieures à d'autres. Par exemple, 250 calories de chocolat et 250 calories de fruits fournissent la même énergie, mais les fruits offrent plus de nutriments essentiels, de fibres et moins de sucre.
                </p>
              </div>
            </div>

            <div className="info-section">
              <div className="info-section-header">
                <strong>Faits intéressants sur les calories et le métabolisme</strong>
              </div>
              <div className="info-section-body">
                <ul style={{ lineHeight: "1.8" }}>
                  <li><strong>Métabolisme basique :</strong> Environ 60-70% de vos calories quotidiennes sont brûlées juste pour les fonctions de base du corps</li>
                  <li><strong>Effet thermique :</strong> Le corps brûle des calories juste en digérant les aliments (environ 10% de l'énergie totale)</li>
                  <li><strong>Différences entre les sexes :</strong> Les hommes ont généralement un taux métabolique plus élevé que les femmes</li>
                  <li><strong>Âge et métabolisme :</strong> Le métabolisme ralentit d'environ 2-8% par décennie après 30 ans</li>
                  <li><strong>Adaptation métabolique :</strong> Le corps s'adapte aux régimes restrictifs en ralentissant le métabolisme</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default CaloriesCalculator;
